module.exports = __webpack_public_path__ + "static/books-69ac840a52f3ec23a554f4046793e7df.jpg";